module.exports = __webpack_public_path__ + "img/edit_black.88d2bfcf.svg";